import {
  NotificationsSubscriptionDocument,
  NotificationsSubscriptionSubscription,
} from 'generated/resources/graphql'

import { useSubscription } from 'modules/core/hooks/useSubscription'

export type Notification = NonNullable<
  NonNullable<
    NotificationsSubscriptionSubscription['notificationsInboxNotificationCreate']
  >['inboxNotification']
>

export const useNotifications = () => {
  const { data } = useSubscription(NotificationsSubscriptionDocument)
  const notification = data?.notificationsInboxNotificationCreate?.inboxNotification

  return {
    notification,
  }
}
